export default "__VITE_ASSET__CxnF59cR__"